import BaseAPI from "./baseAPI";
import { saveAs } from 'file-saver';

class QuestionsBanksAPI extends BaseAPI{
  get entity() {
    return {
      route: `questions_banks`,
      name: 'بنك الأسئلة'
    }
  }

  getByCourse(){
    return new Promise((resolve, reject) => {
      return this.request.get(`${this.getCourseId()}/questions_banks`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  extract(id, title) {
    return new Promise((resolve, reject) => {
      return this.request.get(`questions_banks/${id}/extract_pdf`, {responseType: 'blob'})
        .then(response => {
          saveAs(new Blob([response.data]), `${title}.docx`)
          resolve(this.responseWrapper(response))
        })
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
}

export default new QuestionsBanksAPI()
